import { render } from "./ReportPhasesComponent.vue?vue&type=template&id=17c1cf12"
import script from "./ReportPhasesComponent.vue?vue&type=script&lang=js"
export * from "./ReportPhasesComponent.vue?vue&type=script&lang=js"

import "./ReportPhasesComponent.vue?vue&type=style&index=0&id=17c1cf12&lang=scss"
script.render = render

export default script